import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DocumentsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-privacyPolicy',
    'templateUrl': './privacyPolicy.page.html',
    'styleUrls': ['./privacyPolicy.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class PrivacyPolicyPage extends ViewBasePage implements OnInit {
    public myHTML = {};

    constructor(private documentsService: DocumentsService, private domSanitizer: DomSanitizer, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_PRIVACY_POLICY);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.loadDocument();
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        // this.resetPopoverMenu();
        // this.pushPopoverMenuItem('Show Tour', 'show-privacy-policy-tour');
    }

    public async loadDocument() {
        try {
            await this.uxHelperService.showSpinner('Loading data.');
            const metaData = this.documentsService.getDocumentMetaDataByViewName(Constants.VIEW_PRIVACY_POLICY);
            const doc = await this.documentsService.getByUid(metaData.uid);

            // The doc file may have data.test = xxx.  By default this is considered to be
            // dangerous code and is removed.  Prevent the removal by bypassing this security.
            const trustedDoc = this.domSanitizer.bypassSecurityTrustHtml(doc.contents);
            this.myHTML = trustedDoc;
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            const msg = errorMessage || 'Privacy Policy document not found.';
            this.uxHelperService.showAlert('Error', msg);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
